import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const authUrl = `${process.env.REACT_APP_BACKEND_URL}/api/auth/me`;
const logoutUrl = `${process.env.REACT_APP_BACKEND_URL}/api/auth/logout`;

export default function ProtectedWorkspace({ PageComponent }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState(location.state?.user || null);

  useEffect(() => {
    if (location.state?.user) {
      return;
    }

    axios
      .get(authUrl, { withCredentials: true })
      .then((response) => setUser(response.data))
      .catch(() => navigate("/login", { replace: true }));
  }, [location.state, navigate]);

  const logout = async () => {
    await axios.post(logoutUrl, {}, { withCredentials: true });
    navigate("/login", { replace: true });
  };

  if (!user) {
    return <main className="auth-check" data-testid="workspace-auth-check-state" />;
  }

  return <PageComponent user={user} onLogout={logout} />;
}